import React from 'react';
import { RenderKilogramo, RenderNumber } from '../../../../Utils/renderField/renderReadField';
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

/**
 * Componente para mostrar los detalles de una recepción.
 * @param {Object} props - Propiedades del componente.
 * @param {number} props.index - Índice de la recepción.
 * @param {Object} props.recepcion - Objeto que contiene la información de la recepción.
 * @returns {JSX.Element} Componente de detalles de recepción.
 */
const DetalleRecepcion = (props) => {
    const { index, recepcion } = props;

    return (
        <div className='detalle-recepcion'>
            <h4 className='text-center'> Contenedor {index + 1}</h4>
            <div className="resumen-creacion__fields-row">
                <div className="resumen-creacion__field-vertical">
                    <label className="p-0 m-0">FINCA</label>
                    <span className="gris">{recepcion.finca.nombre}</span>
                </div>

                <div className="resumen-creacion__field-vertical">
                    <label className="p-0 m-0">ID RECEPCIÓN</label>
                    <h5 className="gris bold pl-2">{recepcion.id}</h5>
                </div>
            </div>

            <div className="resumen-creacion__fields-row">
                <div className="resumen-creacion__field-vertical">
                    <label className="p-0 m-0">PESO FINCA</label>
                    <span className="gris">
                        {
                            recepcion.peso_ingreso ?
                                <RenderKilogramo value={recepcion.peso_ingreso} />
                                :
                                "Pesaje pendiente"
                        }
                    </span>
                </div>
                <div className="resumen-creacion__field-vertical">
                    <label className="p-0 m-0">TIPO DE MATERIA PRIMA</label>
                    <span className="gris">{recepcion.tipo_materia.nombre}</span>
                </div>
            </div>

            <div className="resumen-creacion__fields-row">
                <div className="resumen-creacion__field-vertical">
                    <label className="p-0 m-0">FECHA INGRESO MATERIA PRIMA</label>
                    <span className="gris">{recepcion.fecha_entrada ? moment(recepcion.fecha_entrada).format('DD/MM/YYYY HH:mm:ss A') : ''}</span>
                </div>
            </div>

            {/* TABLA DE MATERIAS PRIMAS */}
            <div className="new-table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>MATERIA PRIMA</th>
                            <th className="text-center">PESO FINCA</th>
                            <th>UNIDAD</th>
                            <th className="text-center">KILOGRAMOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recepcion.productos.map((producto, index) => (
                            <tr key={index}>
                                <td className="text-center">{producto.materia_prima_nombre}</td>
                                <td className="text-right td--no-wrap">
                                    <div className="limit-cell-content-width">
                                        <RenderNumber value={producto.peso_finca} decimalScale={2} />
                                    </div>
                                </td>
                                <td className="text-center">{producto.peso_finca_unidad_text}</td>
                                <td className="text-right td--no-wrap">
                                    <div className="limit-cell-content-width">
                                        <RenderNumber value={producto.peso_finca_kg} decimalScale={2} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default DetalleRecepcion;
